import {Injectable} from '@angular/core';
import * as settings from 'src/app/store/settings';

import {Store} from '@ngrx/store';

@Injectable({
    providedIn: 'root'
})
export class MinifyNavigationService {
    const;
    vm$ = this.store.select(settings.selectSettingsState);


    constructor(private store: Store<any>) {


    }

    isMinify() {

        let minify: boolean;
        // tslint:disable-next-line:no-shadowed-variable
        this.vm$.subscribe(state => {
            minify = state.minifyNavigation;
        });
        return minify;
    }

    changeMinifyState() {
        this.store.dispatch(settings.toggleMinifyNavigation());
    }

}
